export class AppConstants {
  public static readonly deployment = 'dev';
  public static readonly emptyRecordMsg = 'No Record Found';
  public static readonly dataListRecsPerPage = 20;
  public static readonly dataListRecsPerPage2 = 10;
  public static readonly dataListPagerLinks = 10;
  public static readonly historyTableRow = 3;
  public static readonly privateworkshopUploadHistoryRecsPerPage = 10;
  public static readonly partnerworkshopUploadHistoryRecsPerPage = 10;
  public static readonly currentFiscalYear = 2023;
  public static readonly mcapFiscalYear = 2021;
  public static readonly uploadSuccessMsg = 'File uploaded successfully!';
  public static readonly validationSuccessMsg =
    'File validation successful. Do you want to continue?';
  public static readonly uploadWarningMsg =
    'File will continue to upload with errors. Do you want to continue?';
  public static readonly uploadErrorMsg =
    'File contained fatal errors, close Upload and return to Workshop.';
  public static readonly customerUploadErrorMsg =
    'The file should reflect the correct sheet name `CustomerTenantList` and the column name `TenantID`';
  public static readonly incentiveName =
    'Microsoft Solution Advisor Incentives';
  public static readonly commonFileTypes = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/bmp',
    'image/jpg'
  ];
  public static readonly commonFileTypesDisplayNames = [
    'doc',
    'pdf',
    'png',
    'jpeg',
    'bmp',
    'jpg',
    'pptx'
  ];
}
